import { render, staticRenderFns } from "./forgotPwd.vue?vue&type=template&id=0fd7770e&scoped=true"
import script from "./forgotPwd.vue?vue&type=script&lang=js"
export * from "./forgotPwd.vue?vue&type=script&lang=js"
import style0 from "./forgotPwd.vue?vue&type=style&index=0&id=0fd7770e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd7770e",
  null
  
)

export default component.exports